"use client";

import { PrismicNextLink } from "@prismicio/next";
import { isFilled } from "@prismicio/client";
import { useState } from "react";

/**
 * @typedef {import("@prismicio/client").Content.NavItemsSlice} NavItemsSlice
 * @typedef {import("@prismicio/react").SliceComponentProps<NavItemsSlice>} NavItemsProps
 * @type {import("react").FC<NavItemsProps>}
 */
const NavItems = ({ slice, context }) => {
  const isMobile = context?.isMobile || false;
  const [isOpen, setIsOpen] = useState(false);

  // Variation Simple - Desktop
  if (slice.variation === "default" && !isMobile) {
    return (
      <div
        data-slice-type={slice.slice_type}
        data-slice-variation={slice.variation}
      >
        {isFilled.link(slice.primary.link) && (
          <PrismicNextLink field={slice.primary.link} className="text-nav hover:underline hover:decoration-green hover:decoration-1 hover:underline-offset-4 transition-all" />
        )}
      </div>
    );
  }

  // Variation Simple - Mobile
  if (slice.variation === "default" && isMobile) {
    return (
      <div
        data-slice-type={slice.slice_type}
        data-slice-variation={slice.variation}
      >
        {isFilled.link(slice.primary.link) && (
          <PrismicNextLink field={slice.primary.link} className="text-nav block py-3 underline decoration-green decoration-1 underline-offset-4" />
        )}
      </div>
    );
  }

  // Variation Avec un sous-menu - Desktop
  if (slice.variation === "withsubmenu" && !isMobile) {
    return (
      <div
        data-slice-type={slice.slice_type}
        data-slice-variation={slice.variation}
      >
        {isFilled.keyText(slice.primary.label) && (
          <div className="relative group">
            <div
              className="flex items-center gap-2 cursor-pointer"
              onClick={() => setIsOpen(!isOpen)}
            >
              <span className="text-nav">{slice.primary.label}</span>
              <svg width="14" height="7" viewBox="0 0 15 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M0.353517 0.353556L7.35352 7.35355L14.3535 0.353557" stroke="#37393A" />
              </svg>
            </div>

            <div className={`${isOpen ? 'flex' : 'hidden'} group-hover:flex flex-col absolute top-full right-0 pt-6.5 z-50`}>
              <div className="bg-beige py-4 min-w-[250px] relative border-t-[0.5px] border-graphite">
                {Array.isArray(slice.primary.link) && slice.primary.link.map((linkItem, index) => (
                  isFilled.link(linkItem) && (
                    <PrismicNextLink key={index} field={linkItem} className="text-nav px-6 py-2 hover:underline hover:decoration-green hover:decoration-1 hover:underline-offset-4 transition-all block" />
                  )
                ))}
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }

  // Variation Avec un sous-menu - Mobile
  if (slice.variation === "withsubmenu" && isMobile) {
    return (
      <div
        data-slice-type={slice.slice_type}
        data-slice-variation={slice.variation}
        className="mb-4"
      >
        {isFilled.keyText(slice.primary.label) && (
          <div className="flex flex-col">
            <span className="text-nav py-3 ">{slice.primary.label}</span>
            {Array.isArray(slice.primary.link) && slice.primary.link.map((linkItem, index) => (
              isFilled.link(linkItem) && (
                <div key={index} className="flex gap-1 items-center">
                  <svg width="6" height="9" viewBox="0 0 6 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M0.353516 8.35355L4.35352 4.35355L0.353516 0.353546" stroke="#37393A" />
                  </svg>
                  <PrismicNextLink field={linkItem} className="text-nav pl-4 py-2 block underline decoration-green decoration-1 underline-offset-4" />
                </div>
              )
            ))}
          </div>
        )}
      </div>
    );
  }

  return null;
};

export default NavItems;
